import React, { useEffect, useState  } from 'react';
import { TreeView,IconPrinter,Button } from "@veneer/core";
import Swal from "sweetalert2";
import ConnectAPI from '../../services/api';
function Pricelistcnf( { consumabledetail,onsuccessgeneral }) {
    const [nodeitem,setnodeitem]=useState([]);
    const [dataresult,setdataresult]=useState([]);
    const [customers, setcustomers]=useState([]);
    const connectApi = new ConnectAPI();
    useEffect(()=>{
        getbypress();
    },[consumabledetail]);
    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }
    const consolid=(status,data)=>{
        setdataresult(data);
        var filter=data.map(item=>item.pressclassification).filter(onlyUnique);
        var items=[
        ];
        if(filter.length>0 ){
            items.push({
            id: 'Classification',
            label: 'Classification',
            icon: <IconPrinter />,
            nodes:[]
        });
        }
        filter.forEach(element => {
           var onenode=[];
            data.filter(x=>x.pressclassification==element).map((item)=>{
                onenode.push({
                    id: item.idcustomer+"-"+item.pressclassification,
                    label: item.customerName,
                    icon: <IconPrinter />,
                    nodes:[]
                });
            })
            items[0].nodes.push(
            {
                id: element,
                label: element,
                icon: <IconPrinter />,
                nodes:onenode
            });
        });
        setnodeitem(items);
    }
    function getbypress(){
        connectApi
        .getWithParams(
            "api/Channels/getunpricelist",
            consumabledetail.idPart ,
            consolid
        )
    }
    const handleSelectedItemsChange = (e, id) => {
        var container=[];
        id.forEach(element => {
            if(element.includes("-")){
                container.push(element.split("-"))
            }
        });
        setcustomers(container);
    };
    const submit =()=>{
        let data= new FormData();
        data.append("array",customers);
        data.append("idpart",consumabledetail.idPart)
        connectApi.post("api/channels/confipricelist",data,consolidgeneral).catch((error) => {
            Swal.fire(
                'Error ' ,
                error,
                'error'
                );
        })
    }
    const consolidgeneral=(status,data)=>{
        onsuccessgeneral(consumabledetail.idPart);
    }
    return(
       <>
            <TreeView
                nodes={nodeitem}
                nodeSelector="multiSelection"
                onChange={handleSelectedItemsChange}
            />
            {(dataresult.length>0)?(<>
                <Button onClick={submit}>Make the change</Button>
            </>):(<>
                Pricelist in order
            </>)}
            
       </>
    );
}
export default Pricelistcnf;